export default __webpack_public_path__ + "static/media/1322.3eeefed2.png";